/* eslint-disable angular/controller-as */
import angular from 'angular';

// eslint-disable-next-line angular/controller-name,angular/function-type
angular.module('app')
	.controller('DevMFFormCtrl', /* @ngInject */ ($scope, KformComponents) => {
		$scope.views = KformComponents.components.mf.views;
		$scope.component = angular.copy(KformComponents.components.mf.settings);
		$scope.data = {
			mfField: {},
		};
		$scope.form = { title: 'Unknown form' };
	});
